import { Pipeline, StreamItem } from '../types';
import { PropertyFilterProps } from '@cloudscape-design/components';

export const pipelines: Pipeline[] = [
  {
    avgLatency: 23,
    maxLatency: 45,
    minLatency: 18,
    name: 'user-analytics-pipeline',
    recordsIn: 45823,
    recordsOut: 45823,
    tps: 1527,
    status: 'healthy',
    tags: ['analytics', 'customer'],
    sourceFeeds: 3,
    destinationTables: 2,
    region: 'us-east-1',
    firstCreated: '2024-01-15T10:30:00Z',
    lastUpdated: '2024-11-24T14:22:00Z',
  },
  {
    avgLatency: 67,
    maxLatency: 120,
    minLatency: 45,
    name: 'order-processing-pipeline',
    recordsIn: 32156,
    recordsOut: 32089,
    tps: 1070,
    status: 'healthy',
    tags: ['order', 'critical'],
    sourceFeeds: 2,
    destinationTables: 4,
    region: 'us-east-1',
    firstCreated: '2023-11-20T08:15:00Z',
    lastUpdated: '2024-11-24T13:45:00Z',
  },
  {
    avgLatency: 78,
    maxLatency: 145,
    minLatency: 52,
    name: 'inventory-sync-pipeline',
    recordsIn: 12843,
    recordsOut: 12756,
    tps: 425,
    status: 'in-alarm',
    tags: ['inventory', 'batch'],
    sourceFeeds: 1,
    destinationTables: 3,
    region: 'us-west-2',
    firstCreated: '2024-03-10T16:20:00Z',
    lastUpdated: '2024-11-24T12:18:00Z',
  },
  {
    avgLatency: 34,
    maxLatency: 89,
    minLatency: 22,
    name: 'payment-gateway-pipeline',
    recordsIn: 89234,
    recordsOut: 89234,
    tps: 2974,
    status: 'healthy',
    tags: ['payment', 'critical'],
    sourceFeeds: 4,
    destinationTables: 1,
    region: 'us-east-1',
    firstCreated: '2023-08-05T12:00:00Z',
    lastUpdated: '2024-11-24T15:30:00Z',
  },
  {
    avgLatency: 45,
    maxLatency: 78,
    minLatency: 32,
    name: 'customer-data-pipeline',
    recordsIn: 23456,
    recordsOut: 23398,
    tps: 780,
    status: 'healthy',
    tags: ['customer', 'batch'],
    sourceFeeds: 2,
    destinationTables: 2,
    region: 'eu-west-1',
    firstCreated: '2024-02-28T09:45:00Z',
    lastUpdated: '2024-11-24T11:22:00Z',
  },
  {
    avgLatency: 12,
    maxLatency: 28,
    minLatency: 8,
    name: 'notification-service-pipeline',
    recordsIn: 156789,
    recordsOut: 156789,
    tps: 5226,
    status: 'healthy',
    tags: ['notification', 'real-time'],
    sourceFeeds: 5,
    destinationTables: 3,
    region: 'us-east-1',
    firstCreated: '2023-12-12T14:30:00Z',
    lastUpdated: '2024-11-24T16:10:00Z',
  },
  {
    avgLatency: 56,
    maxLatency: 98,
    minLatency: 34,
    name: 'audit-log-pipeline',
    recordsIn: 78234,
    recordsOut: 78234,
    tps: 2608,
    status: 'healthy',
    tags: ['audit', 'critical'],
    sourceFeeds: 3,
    destinationTables: 1,
    region: 'us-west-2',
    firstCreated: '2023-09-18T11:15:00Z',
    lastUpdated: '2024-11-24T13:55:00Z',
  },
  {
    avgLatency: 234,
    maxLatency: 456,
    minLatency: 156,
    name: 'ml-training-pipeline',
    recordsIn: 9876,
    recordsOut: 9823,
    tps: 327,
    status: 'error',
    tags: ['ml', 'batch'],
    sourceFeeds: 1,
    destinationTables: 2,
    region: 'us-west-2',
    firstCreated: '2024-05-22T13:20:00Z',
    lastUpdated: '2024-11-24T10:35:00Z',
  },
  {
    avgLatency: 89,
    maxLatency: 134,
    minLatency: 67,
    name: 'backup-sync-pipeline',
    recordsIn: 34567,
    recordsOut: 34567,
    tps: 1152,
    status: 'disabled',
    tags: ['backup'],
    sourceFeeds: 2,
    destinationTables: 1,
    region: 'eu-central-1',
    firstCreated: '2024-01-08T07:30:00Z',
    lastUpdated: '2024-11-20T09:15:00Z',
  },
  {
    avgLatency: 123,
    maxLatency: 198,
    minLatency: 89,
    name: 'data-warehouse-pipeline',
    recordsIn: 234567,
    recordsOut: 234234,
    tps: 7808,
    status: 'healthy',
    tags: ['warehouse', 'batch'],
    sourceFeeds: 6,
    destinationTables: 5,
    region: 'us-east-1',
    firstCreated: '2023-07-01T15:45:00Z',
    lastUpdated: '2024-11-24T14:48:00Z',
  },
];

export const dashboardPipelines: StreamItem[] = [
  {
    name: 'user-analytics-pipeline',
    status: 'Active',
    tps: '4,250',
    bufferInterval: '23ms',
    destination: 'S3 - analytics-bucket',
    cost: '$42.80',
  },
  {
    name: 'order-processing-pipeline',
    status: 'Active',
    tps: '2,150',
    bufferInterval: '67ms',
    destination: 'Lambda - order-processor',
    cost: '$28.50',
  },
  {
    name: 'inventory-sync-pipeline',
    status: 'Degraded',
    tps: '1,890',
    bufferInterval: '78ms',
    destination: 'DynamoDB - inventory-table',
    cost: '$35.20',
  },
  {
    name: 'payment-gateway-pipeline',
    status: 'Active',
    tps: '850',
    bufferInterval: '34ms',
    destination: 'S3 - payments-bucket',
    cost: '$12.40',
  },
  {
    name: 'customer-data-pipeline',
    status: 'Active',
    tps: '650',
    bufferInterval: '45ms',
    destination: 'CloudWatch - customer-logs',
    cost: '$15.80',
  },
  {
    name: 'notification-service-pipeline',
    status: 'Active',
    tps: '5,680',
    bufferInterval: '12ms',
    destination: 'SQS - notification-queue',
    cost: '$78.20',
  },
  {
    name: 'audit-log-pipeline',
    status: 'Active',
    tps: '320',
    bufferInterval: '56ms',
    destination: 'S3 - audit-bucket',
    cost: '$8.90',
  },
  {
    name: 'ml-training-pipeline',
    status: 'Error',
    tps: '0',
    bufferInterval: '234ms',
    destination: 'S3 - ml-training-bucket',
    cost: '$0.00',
  },
  {
    name: 'backup-sync-pipeline',
    status: 'Active',
    tps: '89',
    bufferInterval: '89ms',
    destination: 'Glacier - backup-vault',
    cost: '$4.50',
  },
  {
    name: 'data-warehouse-pipeline',
    status: 'Active',
    tps: '1,234',
    bufferInterval: '123ms',
    destination: 'Redshift - warehouse-cluster',
    cost: '$56.30',
  },
];

export const filteringOptions: PropertyFilterProps.FilteringOption[] = [
  {
    label: 'production',
    propertyKey: 'tags',
    value: 'production',
  },
  {
    label: 'analytics',
    propertyKey: 'tags',
    value: 'analytics',
  },
  {
    label: 'payment',
    propertyKey: 'tags',
    value: 'payment',
  },
  {
    label: 'inventory',
    propertyKey: 'tags',
    value: 'inventory',
  },
  {
    label: 'order',
    propertyKey: 'tags',
    value: 'order',
  },
  {
    label: 'customer',
    propertyKey: 'tags',
    value: 'customer',
  },
  {
    label: 'notification',
    propertyKey: 'tags',
    value: 'notification',
  },
  {
    label: 'audit',
    propertyKey: 'tags',
    value: 'audit',
  },
  {
    label: 'ml',
    propertyKey: 'tags',
    value: 'ml',
  },
  {
    label: 'backup',
    propertyKey: 'tags',
    value: 'backup',
  },
  {
    label: 'warehouse',
    propertyKey: 'tags',
    value: 'warehouse',
  },
  {
    label: 'real-time',
    propertyKey: 'tags',
    value: 'real-time',
  },
  {
    label: 'batch',
    propertyKey: 'tags',
    value: 'batch',
  },
  {
    label: 'critical',
    propertyKey: 'tags',
    value: 'critical',
  },
  {
    label: 'experimental',
    propertyKey: 'tags',
    value: 'experimental',
  },
];

export const filteringProperties: PropertyFilterProps.FilteringProperty[] = [
  {
    groupValuesLabel: 'Pipeline name values',
    key: 'name',
    operators: ['=', '!=', ':', '!:', '^', '!^'],
    propertyLabel: 'Pipeline name',
  },
  {
    defaultOperator: '=',
    groupValuesLabel: 'Tag values',
    key: 'tags',
    operators: ['=', '!='],
    propertyLabel: 'Tags',
  },
  {
    groupValuesLabel: 'Source SNS values',
    key: 'sns_source_name',
    operators: ['=', '!=', ':', '!:', '^', '!^'],
    propertyLabel: 'Source SNS',
  },
  {
    groupValuesLabel: 'Destination table values',
    key: 'destination_table_name',
    operators: ['=', '!=', ':', '!:', '^', '!^'],
    propertyLabel: 'Destination table',
  },
];
